import { render, staticRenderFns } from "./login-auth.vue?vue&type=template&id=366e2915&scoped=true"
import script from "./login-auth.vue?vue&type=script&lang=js"
export * from "./login-auth.vue?vue&type=script&lang=js"
import style0 from "./login-auth.vue?vue&type=style&index=0&id=366e2915&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e2915",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366e2915')) {
      api.createRecord('366e2915', component.options)
    } else {
      api.reload('366e2915', component.options)
    }
    module.hot.accept("./login-auth.vue?vue&type=template&id=366e2915&scoped=true", function () {
      api.rerender('366e2915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/profile/components/login-auth.vue"
export default component.exports